<template>
<Teleport to="body">
<div class="popup-container" v-if="modelValue" :class="class">
  <div>
    <div class="popup">
      <div class="popup-header" v-if="$slots.header">
        <slot name="header" />
      </div>
      <a class="close" href="" v-on:click.prevent="close">
        <i class="fa-solid fa-times"></i>
      </a>
      <div class="popup-body" v-if="$slots.default">
        <slot />
      </div>
      <div class="popup-actions" v-if="$slots.actions">
        <slot name="actions" />
      </div>
    </div>
  </div>
</div>
</Teleport>
</template>

<script>
export default {
  props: ["modelValue", "class"],
  methods: {
    close() {
      this.$emit("update:modelValue", null);
    },
  },
}
</script>
